import ResizeObserverPolyfill from 'resize-observer-polyfill';
import { IS_BROWSER } from '../utils/constants';

export const useResizeObserver = () => {
  const ResizeObserverImpl =
    IS_BROWSER && typeof window.ResizeObserver !== 'undefined'
      ? window.ResizeObserver
      : ResizeObserverPolyfill;

  return { ResizeObserverImpl };
};
